// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3yTAm","graphsContainer":"styles_graphsContainer__1Auc_"};